// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  border-radius: 15px;
  background-color: white;
}
  .form__header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
  .form__header__left {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
    }
  .form__header__right {
      display: flex;
      align-items: center;
      font-weight: 400;
    }
  .form__body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    border-top: '1px solid #D0D5DD';
    border-bottom: '1px solid #EAECF0';
    padding: 20px;
  }
  .form__table-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .form__label {
    display: flex;
    width: 100%;
    font-size: 16px;
    font-weight: 100;
    padding-bottom: 10px;
  }
  .form__input-container {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    font-weight: 100;
    line-height: 2.5;
    border-radius: 8px;
    border: 1px solid #d0d5dd;
    padding: 1px 14px 1px 14px;
    margin-bottom: 15px;
  }
.form__title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.form__title--large {
    font-size: 18px;
    font-weight: 400;
    padding-bottom: 5px;
  }
.form__title--small {
    font-size: 16px;
    font-weight: 100;
  }

/* @media screen and (max-width: 1050px) {
  .form__header {
    flex-direction: column;
    align-items: flex-start;
  }
  .form__title {
    margin-bottom: 10px;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/components/Form.pcss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AAwDzB;EAvDE;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;EAYf;EAXE;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,gBAAgB;IAClB;EACA;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;IAClB;EAEF;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,+BAA+B;IAC/B,kCAAkC;IAClC,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;EACrB;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAU7B;AATE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACA;IACE,eAAe;IACf,gBAAgB;EAClB;;AAGF;;;;;;;;GAQG","sourcesContent":["$midDesktop: 990px;\n$smallDesktop: 750px;\n.form {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #ccc;\n  border-radius: 15px;\n  background-color: white;\n  &__header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    &__left {\n      display: flex;\n      align-items: center;\n      font-size: 16px;\n      font-weight: 400;\n    }\n    &__right {\n      display: flex;\n      align-items: center;\n      font-weight: 400;\n    }\n  }\n  &__body {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n    border-top: '1px solid #D0D5DD';\n    border-bottom: '1px solid #EAECF0';\n    padding: 20px;\n  }\n  &__table-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  &__label {\n    display: flex;\n    width: 100%;\n    font-size: 16px;\n    font-weight: 100;\n    padding-bottom: 10px;\n  }\n  &__input-container {\n    width: 100%;\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    font-weight: 100;\n    line-height: 2.5;\n    border-radius: 8px;\n    border: 1px solid #d0d5dd;\n    padding: 1px 14px 1px 14px;\n    margin-bottom: 15px;\n  }\n}\n.form__title {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  &--large {\n    font-size: 18px;\n    font-weight: 400;\n    padding-bottom: 5px;\n  }\n  &--small {\n    font-size: 16px;\n    font-weight: 100;\n  }\n}\n\n/* @media screen and (max-width: 1050px) {\n  .form__header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .form__title {\n    margin-bottom: 10px;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
